// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fc-menu {\n  position: relative;\n  display: inline;\n}\n.fc-menu__content {\n  position: absolute;\n}\n", ""]);
// Exports
module.exports = exports;
